import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=112c0acc&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=112c0acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112c0acc",
  null
  
)

export default component.exports